import { OrganizationTypeID, AccountFeatureName } from '@karehero/models';
export { OrganizationTypeID };

export enum AccountRole {
  ADMIN = 'KareHero Administrator',
  ORG_OWNER = 'Organization Owner',
  MEMBER = 'Member',
  PARTNER_ADMIN = 'Referring Partner Admin',
  NONE = 'none',
}

export enum Feature {
  CARE_CIRCLE = 'careCircle',
  ATTENDANCE_ALLOWANCE = 'attendanceAllowance',
  FINANCIAL_STATUS = 'financialStatus',
  EXTERNAL_REFERRAL_FORM = 'externalReferralForm',
  ALLOW_TOKENLESS_REGISTRATION = 'allowTokenlessRegistration',
  IFA_PORTAL = 'ifaPortal',
  CARE_ASSESSMENT = 'careAssessment',
  POA = 'poa',
  SHORTLISTS_V2 = 'memberShortlists',
  BACKTESTING = 'backtesting',
  DYNAMIC_CHAT_SANDBOX = 'dynamicChatSandbox',
}

export const accountFeatureToTenantFeature: Record<
  AccountFeatureName,
  Feature
> = {
  [AccountFeatureName.CARE_ASSESSMENT]: Feature.CARE_ASSESSMENT,
  [AccountFeatureName.POWER_OF_ATTORNEY]: Feature.POA,
};

export interface ActiveFeatureVersions {
  benefitsCalculator?: 'v1' | 'v2';
}

export enum Permission {
  BOOK_CALL = 'bookCall',
}

export interface Session {
  isAuthenticated: boolean;
  isOnboarded: boolean;
  isVerified: boolean;
  isNewKindeAccount: boolean;
  isReferringPartner: boolean;
}

export interface Tenant {
  accountRole: AccountRole;
  organizationTypeId: OrganizationTypeID;
  session: Session;
  features: Feature[];
  featuresReady: boolean;
  permissions: Permission[];
  activeFeatureVersions: ActiveFeatureVersions;
}
